module.exports = __webpack_public_path__ + "static/media/22ESCWA2.3e8277ef.jpg";